// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsAccountSaveUserSaveUserContactInfoRequestModel {
    static getAttributeTypeMap() {
        return ScriptsAccountSaveUserSaveUserContactInfoRequestModel.attributeTypeMap;
    }
}
ScriptsAccountSaveUserSaveUserContactInfoRequestModel.discriminator = undefined;
ScriptsAccountSaveUserSaveUserContactInfoRequestModel.additionalProperties = false;
ScriptsAccountSaveUserSaveUserContactInfoRequestModel.attributeTypeMap = [
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
    {
        "name": "isPreferred",
        "baseName": "isPreferred",
        "type": "boolean"
    },
];
//# sourceMappingURL=scriptsAccountSaveUserSaveUserContactInfoRequestModel.js.map